module.exports = __webpack_public_path__ + "static/media/whatWeOfferSelfProduction.d252c643.svg";